var jQuery = require('jquery');

import { addNotification } from './notifications';

jQuery(document).on('change', '#sp_channel_select', function (e) 
{
    jQuery( '#sp_channel_switcher' ).submit();
});

// ------------------------------------------------------------
// Activity tracking
// ------------------------------------------------------------

(function () {
    if (typeof window.sp_activity === 'undefined' || !window.sp_activity.enabled) {
        return;
    }

    const AJAX_URL = typeof window.ajax_url !== 'undefined' ? window.ajax_url : '/wp-admin/admin-ajax.php';
    const ACTION = 'sp_activity_ping';
    const HEARTBEAT_MS = 20000; // 20s
    const IDLE_THRESHOLD_MS = 60000; // 60s inactivity
    const WINDOW_CAP_SECONDS = 30; // cap per beat
    const LEADER_TTL_MS = 40000;
    const LEADER_KEY = 'sp-activity-leader';
    const LAST_ACTIVITY_KEY = 'sp-activity-last';
    const SESSION_KEY = 'sp-activity-session';
    const USER_KEY = 'sp-activity-user';
    const currentUserId = window.sp_activity.user_id || 0;

    const tabId = crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2);
    let hasFocus = !document.hidden;
    let lastBeat = Date.now();

    // Ensure session key shared across tabs and reset on user switch
    let storedUserId = parseInt(localStorage.getItem(USER_KEY) || '0', 10);
    let sessionKey = localStorage.getItem(SESSION_KEY);
    if (!sessionKey || storedUserId !== currentUserId) {
        sessionKey = crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2);
        localStorage.setItem(SESSION_KEY, sessionKey);
        localStorage.setItem(USER_KEY, String(currentUserId));
    }

    // Activity recording
    const bumpActivity = () => {
        localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
    };

    ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'].forEach(ev => {
        window.addEventListener(ev, bumpActivity, { passive: true });
    });

    document.addEventListener('visibilitychange', () => {
        hasFocus = !document.hidden;
        if (hasFocus) bumpActivity();
    });

    // Leader election
    function isLeader() {
        const raw = localStorage.getItem(LEADER_KEY);
        if (!raw) return false;
        try {
            const data = JSON.parse(raw);
            return data.leaderTabId === tabId && data.expiresAt > Date.now();
        } catch (e) {
            return false;
        }
    }

    function tryBecomeLeader() {
        const raw = localStorage.getItem(LEADER_KEY);
        let takeOver = false;
        if (!raw) {
            takeOver = true;
        } else {
            try {
                const data = JSON.parse(raw);
                if (data.expiresAt < Date.now()) takeOver = true;
            } catch (e) {
                takeOver = true;
            }
        }
        if (takeOver) {
            localStorage.setItem(LEADER_KEY, JSON.stringify({
                leaderTabId: tabId,
                expiresAt: Date.now() + LEADER_TTL_MS
            }));
        }
    }

    setInterval(tryBecomeLeader, 5000);
    tryBecomeLeader();

    // Heartbeat sender
    function sendBeat(activeSeconds, { bestEffort = false } = {}) {
        const payload = new URLSearchParams();
        payload.append('action', ACTION);
        payload.append('_ajax_nonce', window.sp_activity.nonce);
        payload.append('session_key', sessionKey);
        payload.append('active_seconds', Math.max(0, Math.round(activeSeconds)).toString());

        if (bestEffort && navigator.sendBeacon) {
            const blob = new Blob([payload.toString()], { type: 'application/x-www-form-urlencoded' });
            navigator.sendBeacon(AJAX_URL, blob);
            return;
        }

        fetch(AJAX_URL, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: payload.toString()
        })
        .then(res => res.json())
        .then(data => {
            if (data && data.success && data.data && data.data.session_key && data.data.session_key !== sessionKey) {
                sessionKey = data.data.session_key;
                localStorage.setItem(SESSION_KEY, sessionKey);
                localStorage.setItem(USER_KEY, String(currentUserId));
            }
        })
        .catch(() => {});
    }

    setInterval(() => {
        if (!isLeader()) return;

        // renew leadership
        localStorage.setItem(LEADER_KEY, JSON.stringify({
            leaderTabId: tabId,
            expiresAt: Date.now() + LEADER_TTL_MS
        }));

        const now = Date.now();
        const windowSeconds = Math.min(WINDOW_CAP_SECONDS, (now - lastBeat) / 1000);
        lastBeat = now;

        const lastAct = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || '0', 10);
        const isActive = hasFocus && (now - lastAct) <= IDLE_THRESHOLD_MS;

        const activeSeconds = isActive ? windowSeconds : 0;
        sendBeat(activeSeconds);
    }, HEARTBEAT_MS);

    // Final best-effort sync on unload/hidden
    const flush = () => {
        if (!isLeader()) return;
        const now = Date.now();
        const lastAct = parseInt(localStorage.getItem(LAST_ACTIVITY_KEY) || '0', 10);
        const isActive = hasFocus && (now - lastAct) <= IDLE_THRESHOLD_MS;
        if (!isActive) return;
        const windowSeconds = Math.min(WINDOW_CAP_SECONDS, (now - lastBeat) / 1000);
        sendBeat(windowSeconds, { bestEffort: true });
    };

    window.addEventListener('beforeunload', flush);
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) flush();
    });

    // Initialize last activity so immediate focus counts
    bumpActivity();
})();